import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  routeDownloadStarted: false,
  downloadRouteId: null,
};

export const helperSlice = createSlice({
  name: "helper",
  initialState,
  reducers: {
    setRouteDownloadStarted: (state, action) => {
      state.routeDownloadStarted = action.payload;
    },
    setDownloadRouteId: (state, action) => {
      state.downloadRouteId = action.payload;
    },
  },
});

export const { setRouteDownloadStarted, setDownloadRouteId } =
  helperSlice.actions;

export default helperSlice.reducer;
